<div class="trigger-card" *ngIf="!trigger.completed">
    <div class="trigger-card_header">
        <span class="title" *ngIf="!trigger.completed">{{ 'FUNNEL.dealPage.triggers.title' | translate }}</span>
        <span class="title" *ngIf="trigger.completed">{{ 'FUNNEL.dealPage.triggers.titleCompleted' | translate }}</span>
        <span class="date">{{trigger.date | date:'d/M/yy'}}</span>
    </div>
    <div class="trigger-card_body">
        <p *ngIf="trigger.type === 'meeting'">{{'FUNNEL.dealPage.triggers.meeting' | translate}}</p>
        <p *ngIf="trigger.type === 'doc'">{{'FUNNEL.dealPage.triggers.document' | translate: translateDocParams }}</p>
        <p *ngIf="trigger.type === 'form'">{{'FUNNEL.dealPage.triggers.form' | translate: {form: trigger.data.form.title} }}</p>
    </div>
    <div class="trigger-card_footer" *ngIf="buttonModalText">
        <ng-container *ngIf="!trigger.completed">
            <onwac-button 
            *ngIf="trigger.type === 'doc'" 
            [text]="'FUNNEL.dealPage.triggers.buttons.download' | translate:translateDocParams" 
            [type]="'text'" 
            [extra_clases]="'block'"
            (click)="downloadFile()"></onwac-button>
            <onwac-button [text]="buttonModalText" [extra_clases]="'block'" (click)="doTriggerAction(trigger.type)"></onwac-button>
        </ng-container>
        <ng-container *ngIf="trigger.completed">
            <div class="w-100 d-flex justify-content-end">
                <i class="material-icons cursor accent" (click)="doTriggerAction(trigger.type)">edit</i>
                <i *ngIf="trigger.type === 'doc'" class="material-icons cursor accent" (click)="downloadFile()">get_app</i>
            </div>
        </ng-container>
    </div>
</div>

<app-multiupload-files *ngIf="trigger.type === 'doc'" [toggler]="documentToggler" (callback)="multiuploadCallback($event)"></app-multiupload-files>
<app-meeting-selector *ngIf="trigger.type === 'meeting'" [toggler]="meetingToggler" [coordinator]="trigger.coordinator" (onArrangeDate)="onArrangeDate($event)"></app-meeting-selector>
<onwac-modal 
*ngIf="trigger.type === 'form'"
[title]="'FUNNEL.dealPage.triggers.modal.form' | translate" 
[show]="formToggler.show"
(callback)="onSaveForm($event)">
    <div slot="content">
        <div>
            <flexiform-interpreter *ngIf="triggerForm" 
            [schema]="triggerForm" 
            [logo]="''"
            [options]="{
                fullScreen: false,
                progressBar: false,
                formControls: false
            }"
            (onSaveForm)="onSaveForm($event)"></flexiform-interpreter>
        </div>
    </div>
    <div slot="footer" class="button-row full-width">
        <onwac-button [text]="'CANCELAR'" [type]="'text'" [extra_clases]="'block'" (click)="formToggler.close()"></onwac-button>
        <onwac-button [text]="'GUARDAR'" [extra_clases]="'block'" (click)="formComponent.saveForm()"></onwac-button>
    </div>
</onwac-modal>

<onwac-snackbar 
[status_class]="snackbar.status_class"
[text]="snackbar.text"
[activate]="snackbar.active"
[autoClose]="snackbar.autoClose"
(hidden)="snackbar.deactivate()"
></onwac-snackbar>